<template>
  <s-dialog
    :visible.sync="dialogVisible"
    :title="$i18n('Notice')"
    size="normal"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <div class="leave-warning-content">
      {{
        $i18n(
          'There are still X orders left within this checking, are you sure to exit without completing them?'
        ).replace('X', orderLeft.toString())
      }}
    </div>
    <span slot="footer" class="dialog-footer">
      <s-button type="primary" @click="handleCancel">
        {{ $i18n('Cancel') }}
      </s-button>
      <s-button @click="handleConfirm">
        {{ $i18n('Yes, exit') }}
      </s-button>
    </span>
  </s-dialog>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class LeavePageWarningDialog extends Vue {
  @Prop({ default: 0 }) readonly orderLeft!: number;
  @Prop({ default: 0 }) readonly isStartWithPickup!: number;

  dialogVisible = false;
  private resolveLeave: ((value: boolean) => void) | null = null;

  /**
   * 显示弹窗，返回 Promise，用户确认或取消后 resolve
   */
  show(): Promise<boolean> {
    return new Promise((resolve) => {
      this.dialogVisible = true;
      this.resolveLeave = resolve;
    });
  }

  handleConfirm() {
    this.dialogVisible = false;
    if (this.resolveLeave) {
      this.resolveLeave(true);
      this.resolveLeave = null;
    }
  }

  handleCancel() {
    this.dialogVisible = false;
    if (this.resolveLeave) {
      this.resolveLeave(false);
      this.resolveLeave = null;
    }
  }
}
</script>

<style scoped lang="scss">
.leave-warning-content {
  padding: 10px 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
